export const DRAWER_WIDTH = 250;
export const APPBAR_HEIGHT = 56;
